import React from 'react';
import { block } from '../../utils/cn';
import { prepareHighlightParts } from './utils';
import './Highlight.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var b = block('highlight');
export function Highlight(_ref) {
  var text = _ref.text,
    className = _ref.className;
  if (!text) {
    return null;
  }
  var content = prepareHighlightParts(text);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: content.map(function (_ref2, ind) {
      var substr = _ref2.substr,
        highlighted = _ref2.highlighted;
      return highlighted ? /*#__PURE__*/_jsx("span", {
        className: b('mark', className),
        children: substr
      }, ind) : substr;
    })
  });
}
// #sourceMappingURL=Highlight.js.map